import _ from "lodash";
import { LEVEL_REWARD_CHECKBOXES } from "./constants";
import levelRewardTransform from "@/store/modules/basic_rewards/transform";
import levelActivityTransform from "@/store/modules/basic_level_activities/transform";
import { PROGRAM_REQUIREMENT_ITEMS } from "@/store/modules/basic_programs/constants";
import moment from "moment";

function convertLevelModel(data, subgroupId) {
  let level = {
    Id: data.id,
    Name: data.name,
    Points: data.endPoint,
    Deadline: data.endDate,
    Description: data.description,
    LevelOrder: data.levelOrder,
    Rewards: convertListLevelRewardModel(
      data.programLevelRewards,
      data.id,
      subgroupId
    ),
    Activities: data.programLevelActivities
      ? convertListLevelActivityModel(data.programLevelActivities)
      : [],
    Paths: data.programLevelPaths
      ? convertListLevelPathModel(data.programLevelPaths)
      : [],
    ProgramId: data.programId,
    ListRewardChecked: extractListRewardChecked(data.programLevelRewards)
  };
  return level;
}

function handleTobaccoRequirementItems(programLevels) {
  programLevels.forEach(o => {
    o.programRequirementItems.forEach(i => {
      // check level id
      if (i.programLevelId === o.id) {
        switch (i.itemCode) {
          case PROGRAM_REQUIREMENT_ITEMS.ACTIVITY:
            o.programLevelActivities.push({
              activityCode: i.nameOfItem,
              activityId: i.itemId,
              programLevelId: i.programLevelId,
              programLevelDescription: null,
              subgroupId: i.subgroupId,
              subgroupName: i.subgroupName,
              type: i.typeOfItem,
              requirementItemId: i.id,
              isRequirementItem: true
            });
            break;
          case PROGRAM_REQUIREMENT_ITEMS.PATH:
            o.programLevelPaths.push({
              name: i.nameOfItem,
              pathId: i.itemId,
              programLevelId: i.programLevelId,
              programLevelDescription: null,
              subgroupId: i.subgroupId,
              subgroupName: i.subgroupName,
              pathType: i.typeOfItem,
              requirementItemId: i.id,
              isRequirementItem: true
            });
            break;
          default:
            break;
        }
      }
    });
  });
}

function extractListRewardChecked(programLevelRewards) {
  let list = [];
  _.forEach(programLevelRewards, function(item) {
    list.push(item.rewardType);
  });
  return list;
}

function convertLevelRawModel(data) {
  let level = {
    id: data.Id,
    name: data.Name,
    endPoint: data.Points,
    endDate: data.Deadline
      ? moment(data.Deadline)
          .utc()
          .format()
      : null,
    description: data.Description,
    levelOrder: data.LevelOrder,
    programId: data.ProgramId,
    campaignId: data.CampaignId,
    programLevelRewards: levelRewardTransform.convertListLevelRewardRawModel(
      data.Rewards,
      data.Id
    ),
    programLevelActivities: levelActivityTransform.convertListLevelActivityRawModel(
      data.Activities,
      data.Id
    )
  };
  return level;
}

function convertLevelRewardModel(data) {
  let levelReward = {
    RewardId: data.rewardId,
    RewardCode: data.code,
    Description: data.description,
    LevelId: data.programLevelId,
    Amount: data.rewardAmount,
    RewardType: data.rewardType,
    CampaignId: {
      utid: data.campaignId,
      rewardName: data.description
    },
    SubgroupId: data.subgroupId,
    SubgroupName: data.subgroupName
  };
  if (data.id) {
    levelReward.Id = data.id;
  }
  return levelReward;
}

function convertListLevelRewardModel(data, levelId, subgroupId) {
  let list = [];
  _.forEach(LEVEL_REWARD_CHECKBOXES, function(rewardType) {
    let reward = {};
    let matchedIndex = -1;
    if (subgroupId === null) {
      matchedIndex = _.findIndex(data, function(i) {
        return i.code === rewardType.value && i.subgroupId === null;
      });
    } else {
      matchedIndex = _.findIndex(data, function(i) {
        return i.code === rewardType.value && i.subgroupId === subgroupId;
      });
    }
    if (matchedIndex > -1) {
      reward = convertLevelRewardModel(data[matchedIndex]);
      reward.IsActive = true;
      reward.SubText = rewardType.text;
      reward.RewardCode = rewardType.value;
      reward.RewardType = rewardType.value;
    } else {
      reward = {
        RewardId: 0,
        RewardCode: rewardType.value,
        Description: "",
        SubText: rewardType.text,
        LevelId: levelId,
        Amount: 0,
        RewardType: rewardType.value,
        CampaignId: {
          id: "",
          name: ""
        },
        IsActive: false,
        SubgroupId: null,
        SubgroupName: null
      };
    }
    list.push(reward);
  });
  return list;
}

function convertLevelActivityModel(data) {
  let levelActivity = {
    ActivityId: data.activityId,
    ActivityCode: data.activityCode,
    Description: data.programLevelDescription,
    LevelId: data.programLevelId,
    ProgramPhaseId: data.programPhaseId,
    ProgramPhasePhaseOrder: data.programPhasePhaseOrder,
    SubgroupId: data.subgroupId,
    SubgroupName: data.subgroupName,
    isRequirementItem: data.isRequirementItem || false,
    requirementItemId: data.requirementItemId || null
  };
  if (data.id) {
    levelActivity.Id = data.id;
  }
  return levelActivity;
}

function convertListLevelActivityModel(data) {
  let list = [];
  data.forEach(item => {
    list.push(convertLevelActivityModel(item));
  });
  return list;
}

function convertLevelPathModel(data) {
  let item = {
    name: data.name,
    pathId: data.pathId,
    pathType: data.pathType,
    pathCategory: data.pathCategory,
    programLevelId: data.programLevelId,
    programLevelName: data.programLevelName,
    subgroupId: data.subgroupId,
    subgroupName: data.subgroupName,
    isRas: data.isRequirementItem || false,
    isRequirementItem: data.isRequirementItem || false,
    requirementItemId: data.requirementItemId || null
  };
  if (data.id) {
    item.id = data.id;
  }
  return item;
}

function convertListLevelPathModel(data) {
  let list = [];
  data.forEach(item => {
    list.push(convertLevelPathModel(item));
  });
  return list;
}

function convertListLevelModel(data, subgroupId) {
  let list = [];
  _.forEach(data, function(item) {
    list.push(convertLevelModel(item, subgroupId));
  });
  return list;
}

function convertListRawLevelModel(data) {
  let listLevel = [];
  _.forEach(data, function(item) {
    listLevel.push(convertLevelRawModel(item));
  });
  return listLevel;
}

export default {
  convertLevelModel,
  convertLevelRawModel,
  convertListLevelModel,
  convertListRawLevelModel,
  convertLevelRewardModel,
  convertListLevelActivityModel,
  convertListLevelRewardModel,
  handleTobaccoRequirementItems
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_levels/transform.js